// extracted by mini-css-extract-plugin
module.exports = {"scheduleBadge":"ScheduleBadge_scheduleBadge__FfPCV","badgeLabel":"ScheduleBadge_badgeLabel__tZv3n"};